import { checkIsUnknownCompany, useRegistration } from "./useRegistration";

export const TAccountOnly = ({ children }) => {
  const { isUnknownCompany } = useRegistration((state) => ({
    isUnknownCompany: checkIsUnknownCompany(state),
  }));

  if (isUnknownCompany) {
    return children;
  } else {
    return null;
  }
};
